import { defineMessages } from 'react-intl'

export default defineMessages({
  'add': {
    id: 'add',
    defaultMessage: 'Add new Asset',
  },
  'edit': {
    id: 'edit',
    defaultMessage: 'Edit selected Asset details',
  },
  'delete': {
    id: 'delete',
    defaultMessage: 'Delete selected Asset',
  },
  'upload': {
    id: 'upload',
    defaultMessage: 'Upload Field Borders',
  },
  'migrate': {
    id: 'migrate',
    defaultMessage: 'Push Your Fields to the Next Season',
  },
})
